export const somethingWrongMsg = 'Something went wrong, please try again.';
export const noAmountFoundMsg = 'No Amounts Found.';
export const noEnvelopeMsg = 'No Envelope Found.';
export const noHistoryItemMsg =
  'No contributions on record for this particular year. Contact Givelify if this does not match your records.';
export const noWalletMsg =
  'Currently you do not have any payment methods in your wallet. Make your first contribution and add payment method.';
export const noRecurringFoundMsg =
  'Save time by setting a gift to recur. Return here to manage those recurring gifts.';
